import React, { useState } from 'react';
import { Link, useLocation,NavLink } from 'react-router-dom';
import Footer from './Footer';
import {
  HomeIcon,
  DocumentTextIcon,
  ShoppingBagIcon,
  ClipboardDocumentListIcon,
  ChartBarIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  BuildingOfficeIcon,
  UserGroupIcon,
  Cog6ToothIcon,
  ReceiptPercentIcon
} from '@heroicons/react/24/outline';

const SidebarLayout = ({ children, onLogout }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const menuItems = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: HomeIcon,
      path: '/dashboard',
      submenus: []
    },
    {
      key: 'invoices',
      label: 'Invoices',
      icon: DocumentTextIcon,
      path: '/invoices',
      submenus: [
     
        { label: 'Create Invoice', path: '/invoices/create' },
        { label: 'Customers', path: '/customers' },
           { label: 'All Invoices', path: '/invoices' },
        // { label: 'Invoice Templates', path: '/invoices/templates' }
      ]
    },
    {
      key: 'purchases',
      label: 'Purchases',
      icon: ShoppingBagIcon,
      path: '/purchases',
      submenus: [
        { label: 'Create Purchase Invoice', path: '/purchases/orders' },
        { label: 'Suppliers', path: '/purchases/suppliers' },
        { label: 'All Purchase Invoices', path: '/purchases/history' }
      ]
    },
     {
      key: 'quotations',
      label: 'Quotations',
      icon: ShoppingBagIcon,
      path: '/quotations',
      submenus: [
        { label: 'Create Quotation', path: '/quotations/create' },
        { label: 'All Quotations', path: '/quotations/listquotations' }
      ]
    },
    {
      key: 'transactions',
      label: 'Transactions',
      icon: ReceiptPercentIcon,
      path: '/transactions',
      submenus: [
        { label: 'Invoice Receipts', path: '/transactions/receipts' },
         { label: 'All Invoice Receipts', path: '/transactions/listreceipts' },
          { label: 'Receipts', path: '/transactions/greceipts' },

      ]
    },
    {
      key: 'tasks',
      label: 'Tasks',
      icon: ClipboardDocumentListIcon,
      path: '/tasks',
      submenus: [
        { label: 'Create Task', path: '/tasks' },
        // { label: 'Task Management', path: '/tasks/manage' },
        { label: 'All Tasks', path: '/tasks/reports' }
      ]
    },
    {
      key: 'reports',
      label: 'Reports',
      icon: ChartBarIcon,
      path: '/reports',
      submenus: [
        // { label: 'Financial Reports', path: '/reports/financial' },
        { label: 'Sales Invoice Reports', path: '/reports/sales' },
        { label: 'Purchase Invoice Reports', path: '/reports/purchases' },
        { label: 'Task Reports', path: '/reports/tasks' },
        { label: 'Invoice Receipt Reports', path: '/reports/receipts' },
       
         { label: 'VAT Reports', path: '/reports/vat' }
      ]
    }
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <>
    <div className="flex h-screen flex-col lg:flex-row bg-gray-50">
      {/* Sidebar */}
      <div className={`${isOpen ? 'w-64' : 'w-16'} bg-[#23A19B] text-white transition-all duration-300 ease-in-out shadow-xl fixed lg:relative h-screen lg:h-auto z-40 lg:z-auto left-0 top-0 lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-emerald-500">
          {isOpen && (
            <div className="flex items-center space-x-3">
              {/* <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-md"> */}
               <NavLink to="/"><img src="/logo2.png" alt="Company Logo" className="w-50 h-50" /></NavLink>
                {/* <BuildingOfficeIcon className="w-10 h-10 text-emerald-600" /> */}
              {/* </div> */}
              <div>
                <h1 className="text-lg font-bold text-white">Diamond Quality Constructions</h1>
                <p className="text-xs text-emerald-200">Sharjah, UAE</p>
              </div>
            </div>
          )}
          <button
            onClick={toggleSidebar}
            className="p-1 rounded-md hover:bg-emerald-700 transition-colors duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isOpen ? "M15 19l-7-7 7-7" : "M9 5l7 7-7 7"} />
            </svg>
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className="mt-6 px-3">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const hasSubmenu = item.submenus.length > 0;
              const isExpanded = expandedMenus[item.key];
              const isItemActive = isActive(item.path);

              return (
                <li key={item.key}>
                  {hasSubmenu ? (
                    <button
                      onClick={() => toggleSubmenu(item.key)}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-all duration-200 ${
                        isItemActive
                          ? 'bg-emerald-700 text-white shadow-md'
                          : 'text-emerald-100 hover:bg-emerald-700 hover:text-white'
                      }`}
                    >
                      <div className="flex items-center space-x-3">
                        <Icon className="w-5 h-5" />
                        {isOpen && <span className="font-medium">{item.label}</span>}
                      </div>
                      {isOpen && (
                        isExpanded ?
                          <ChevronDownIcon className="w-4 h-4" /> :
                          <ChevronRightIcon className="w-4 h-4" />
                      )}
                    </button>
                  ) : (
                    <Link
                      to={item.path}
                      className={`flex items-center px-3 py-2 rounded-lg transition-all duration-200 ${
                        isItemActive
                          ? 'bg-emerald-700 text-white shadow-md'
                          : 'text-emerald-100 hover:bg-emerald-700 hover:text-white'
                      }`}
                    >
                      <Icon className="w-5 h-5" />
                      {isOpen && <span className="ml-3 font-medium">{item.label}</span>}
                    </Link>
                  )}

                  {/* Submenu */}
                  {hasSubmenu && isExpanded && isOpen && (
                    <ul className="mt-2 ml-6 space-y-1">
                      {item.submenus.map((submenu, index) => (
                        <li key={index}>
                          <Link
                            to={submenu.path}
                            className={`block px-3 py-2 text-sm rounded-md transition-all duration-200 ${
                              isActive(submenu.path)
                                ? 'bg-emerald-500 text-white'
                                : 'text-emerald-200 hover:bg-emerald-600 hover:text-white'
                            }`}
                          >
                            {submenu.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Footer */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-emerald-500">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
              <UserGroupIcon className="w-4 h-4 text-white" />
            </div>
            {isOpen && (
              <div className="flex-1">
                <p className="text-sm font-medium text-white">Admin User</p>
                <p className="text-xs text-emerald-200">admin@dqcc.ae</p>
              </div>
            )}
            {isOpen && (
              <button className="p-1 rounded-md hover:bg-emerald-700 transition-colors duration-200">
                <Cog6ToothIcon className="w-4 h-4 text-emerald-200" />
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden w-full">
        {/* Top Bar */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-3 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              <button
                onClick={toggleSidebar}
                className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 lg:hidden shrink-0"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <div className="hidden sm:block h-12 sm:h-20 w-auto overflow-hidden shrink-0">
                <img src="/logo2.jpeg" alt="Company Logo" className="h-full w-auto" />
              </div>
            </div>

            <div className="flex items-center gap-2 sm:gap-4 ml-auto">
              <div className="text-right hidden sm:block">
                <p className="text-xs sm:text-sm font-medium text-gray-900">Welcome back!</p>
                <p className="text-xs text-gray-500 hidden sm:block">{new Date().toLocaleDateString()}</p>
              </div>
              <button
                onClick={onLogout}
                className="px-2 sm:px-3 py-1 text-xs font-semibold rounded bg-red-100 text-red-700 hover:bg-red-200 shrink-0"
              >
                Logout
              </button>
              <div className="w-8 sm:w-10 h-8 sm:h-10 bg-emerald-600 rounded-full flex items-center justify-center shrink-0">
                <span className="text-white font-bold text-xs sm:text-sm">A</span>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-gray-50 p-3 sm:p-6">
          {children}
        </main>
      </div>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 lg:hidden z-30"
          onClick={toggleSidebar}
        ></div>
      )}
     
    </div>
 <Footer/>
    </>
    
  );
};

export default SidebarLayout;